import React from 'react'
import { StyleSheet, TouchableOpacity } from 'react-native'
import { colors } from 'src/assets/colors'
import { FontAwesomeIconWrapper } from 'src/components/FontAwesomeIcon'
import { st } from 'src/locales'
import { NavigationScreenTitle } from 'src/navigation/components/NavigationModalTitle'

const styles = StyleSheet.create({
  touchable: {
    paddingLeft: 12,
    width: 55,
  },
})

export const NavigationScreenBackButton = ({ onPress }: { onPress: () => void }) => (
  <TouchableOpacity
    style={styles.touchable}
    onPress={onPress}
    accessibilityLabel={st.common.accessibilityBackButton()}
    accessibilityHint={st.common.accessibilityBackButtonHint()}
    accessibilityRole='button'
  >
    <FontAwesomeIconWrapper color={colors.gray6} size={18} icon='chevron-left' />
  </TouchableOpacity>
)

export const NavigationScreenBackButtonOptions = (navigation: any, title: string) => ({
  headerLeft: function headerLeft() {
    return <NavigationScreenBackButton onPress={() => navigation.pop()} />
  },
  headerTitle: function headerTitle() {
    return <NavigationScreenTitle title={title} />
  },
})
